<div class="hist-wrap">
  <h5 class="fw-bold mb-3">Historial de viáticos compartidos</h5>

  <div *ngIf="isLoading" class="text-center py-4">
    <div class="spinner-border text-primary" role="status"></div>
  </div>

  <div *ngIf="!isLoading && historyDays.length === 0" class="text-center text-muted py-4">
    No hay registros en el historial.
  </div>

  <div *ngIf="!isLoading && historyDays.length > 0" class="hist-table-outer">
    <table class="hist-table">
      <colgroup>
        <col style="width:12%">
        <col style="width:18%">
        <col style="width:33%">
        <col style="width:14%">
        <col style="width:23%">
      </colgroup>

      <thead>
        <tr>
          <th class="text-center">Fecha / Hora</th>
          <th>Tipo de gasto</th>
          <th>Detalle</th>
          <th class="text-end">Monto</th>
          <th>Aplicado a</th>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngFor="let day of historyDays">

          <tr class="date-row">
            <td colspan="5">{{ day.date_label }}</td>
          </tr>

          <ng-container *ngFor="let entry of day.entries">

            <tr *ngIf="!isServiceLeftEvent(entry.event_type)">
              <td class="td-time">{{ entry.created_at }}</td>
              <td>{{ expenseTypeLabel(entry.expense_type) }}</td>
              <td class="td-detail">{{ entry.detail }}</td>
              <td class="td-amount">{{ formatAmount(entry.amount) }}</td>
              <td>{{ entry.aplicado_a }}</td>
            </tr>

            <tr *ngIf="isServiceLeftEvent(entry.event_type)" class="left-row">
              <td class="td-time td-left-time">{{ entry.created_at }}</td>
              <td class="td-left-label">Finalizado</td>
              <td colspan="3" class="td-left-detail">{{ entry.detail }}</td>
            </tr>

          </ng-container>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>
